type AdvertisementPortals = Record<
  string,
  {
    name: string
    id: string
  }[]
>

export const OPTIONS_ADVERTISEMENTS_PORTALS: AdvertisementPortals = {
  WIGGOT: [],
  I24: [
    { name: 'Subsimple', id: 'SUBSIMPLE' },
    { name: 'Simple', id: 'SIMPLE' },
    { name: 'Destacada', id: 'DESTACADA' },
    { name: 'Super destacada', id: 'SUPER DESTACADA' }
  ],
  CYT: [],
  M3: [
    { id: 'PLATA', name: 'Plata' },
    { name: 'Oro', id: 'ORO' },
    { name: 'Oro premium', id: 'ORO PREMIUM' }
  ],
  LAMUDI: [
    { name: 'Simple', id: 'SIMPLE' },
    { name: 'Destacada', id: 'DESTACADA' }
  ],
  SEGUNDAMANO: [],
  PROPIEDADESCOM: [],
  VIVANUNCIOS: [
    {
      name: 'Simple',
      id: 'SIMPLE'
    },
    { name: 'Destacada', id: 'DESTACADA' }
  ],
  MITULA: [],
  ICASAS: [],
  ALLPROPERTY: [
    { name: 'Simple', id: 'SIMPLE' },
    { name: 'Destacada', id: 'DESTACADA' }
  ],
  EXCELSIOR: [],
  LAHAUS: [],
  NEXIMO: [],
  PORTALTERRENOCOM: [],
  HOUM: [],
  MUDAFY: [],
  FLATMX: [],
  ELINFORMADOR: [],
  MONOPOLIO: []
}
